import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-schools-sysyrm",
  templateUrl: "./schools-sysyrm.component.html",
  styleUrls: ["./schools-sysyrm.component.css"],
})
export class SchoolsSysyrmComponent implements OnInit {
  packages: any = [
    {
      type: "started",
      price: 29.99,
      description: "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
      features: [
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
      ],
    },
    {
      type: "professional",
      price: 59.99,
      description: "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
      features: [
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
      ],
    },
    {
      type: "advanced",
      price: 89.99,
      description: "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
      features: [
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
      ],
    },
  ];

  constructor() {}
  ngOnInit(): void {}
}
